<template>
  <div id="title">
    <h1>{{ title }}</h1>
    <div class="ql-editor" v-html="description"></div>
  </div>
</template>

<script>
export default {
  name: "Content",
  props: {
    title: String,
    description: String,
  },
};
</script>

<style scoped>
#title h1 {
  padding-bottom: 20px;
  font-size: 58px;
  text-align: center;
  font-family: "Barlow", sans-serif;
  font-weight: 500;
}
#title {
  padding: 10px 200px 50px 200px;
}
.ql-editor >>> h4 {
  padding-top: 20px;
  font-size: 25px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
}
.ql-editor >>> p {
  padding-top: 10px;
  font-size: 22px;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
}
.ql-editor >>> img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 1000px) {
  #title {
    padding: 5px 5px 0px 5px;
  }
  #title h1 {
    font-size: 55;
  }
  .ql-editor >>> p {
    font-size: 22px;
    text-align: center;
  }
  .ql-editor >>> img {
    max-width: 100%;
    height: 100px;
    object-fit: cover;
  }
}
</style>
